/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
import { Flex, Text } from '@leverege/ui-elements'
import moment from 'moment'
import React, { useMemo } from 'react'
import { getDuration } from '../components/Utils'

const useDelayOverviewTable = ( fgJob, isFullScreen ) => {
  const getDelays = delayObj => Object.values( delayObj ?? {} )

  const data = useMemo( () => {
    const ss = getDelays( fgJob?.suctionSideJob?.data?.delay ).map( d => ( {
      jobType : 'SS',
      ...d,
    } ) )
    const ps = getDelays( fgJob?.pressureSideJob?.data?.delay ).map( d => ( {
      jobType : 'PS',
      ...d,
    } ) )
    const bnd = getDelays( fgJob?.bondedBladeJob?.data?.delay ).map( d => ( {
      jobType : 'BND',
      ...d,
    } ) )

    const delays = [ ...ss, ...ps, ...bnd ].sort(
      ( a, b ) => b?.startTime - a?.startTime,
    )

    return delays.map( d => ( {
      jobType : d.jobType,
      espDescription : d.descriptionLocal,
      description : d.descriptionEnglish,
      start : d.startTime ?
        moment( d.startTime ).format( 'M/D/YY hh:mm A' ) :
        undefined,
      end : d.endTime ? moment( d.endTime ).format( 'M/D/YY hh:mm A' ) : undefined,
      duration : d.duration ? getDuration( d.duration * 1000 ) : undefined,
    } ) )
  }, [ fgJob ] )

  const columns = useMemo(
    () => [
      {
        id : 'jobType',
        Header : <Text variant='columnHeaderCustom'>Job Type</Text>,
        accessor : item => item.jobType,
      },
      {
        id : 'description',
        Header : <Text variant='columnHeaderCustom'>Description</Text>,
        accessor : item => item,
        Cell : ( { value } ) => (
          <Flex variant='col'>
            <Text
              variant='delayDescriptionTitle'
              style={{ fontSize : isFullScreen ? 20 : 14 }}>
              {value.espDescription}
            </Text>
            <Text
              variant='delayDescriptionSub'
              style={{ fontSize : isFullScreen ? 14 : 12 }}>
              {value.description}
            </Text>
          </Flex>
        ),
      },
      {
        id : 'start',
        Header : <Text variant='columnHeaderCustom'>Start Date & Time</Text>,
        accessor : item => item.start,
      },
      {
        id : 'end',
        Header : <Text variant='columnHeaderCustom'>End Date & Time</Text>,
        accessor : item => item.end,
      },
      {
        id : 'duration',
        Header : <Text variant='columnHeaderCustom'>Delay Duration</Text>,
        accessor : item => item.duration,
      },
    ],
    [ data, isFullScreen ],
  )

  return {
    data1 : data.slice( 0, 3 ),
    data2 : data.slice( 3, 6 ),
    columns,
  }
}

export default useDelayOverviewTable
